/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Button, StandaloneCheckbox, TemporaryDrawer, Typography2 } from '@coursera/cds-core';

import type { DateRangeFilterOption } from 'bundles/enterprise-admin-drawers/components/types';
import { DateRangeInput } from 'bundles/enterprise-ui/components/DateRangeInput';

import _t from 'i18n!nls/enterprise-admin-drawers';

type Props = {
  onClose: () => void;
  selectedDateRange?: DateRangeFilterOption | null;
  onBack: () => void;
  onApply: (dateRange?: DateRangeFilterOption | null) => void;
};

const ExportDrawerDateSelectionView = ({ onBack, onApply, onClose, selectedDateRange }: Props) => {
  const [isAllTimeSelected, setIsAllTimeSelected] = useState<boolean>(Boolean(!selectedDateRange));
  const [currentDateRange, setCurrentDateRange] = useState<DateRangeFilterOption | undefined | null>(selectedDateRange);
  const { HeadingGroup, Content, Actions } = TemporaryDrawer;

  return (
    <TemporaryDrawer open={true} anchor="right" sticky="actions" onClose={onClose}>
      <HeadingGroup data-testid="date-selection-view-header">{_t('Date Range')}</HeadingGroup>
      <Content>
        <StandaloneCheckbox
          checked={isAllTimeSelected}
          onChange={() => setIsAllTimeSelected((prevState) => !prevState)}
          label={_t('All time')}
        />
        <Typography2
          component="p"
          color={isAllTimeSelected ? 'supportText' : 'body'}
          css={{ margin: `var(--cds-spacing-400) 0` }}
        >
          {_t(
            'Select date range to export a grade book to include learner grades for courses that had activity during the selected date range.'
          )}
        </Typography2>
        <DateRangeInput
          disabled={isAllTimeSelected}
          value={currentDateRange || {}}
          onChange={(val) => setCurrentDateRange(val)}
        />
      </Content>
      <Actions data-testid="date-range-filter-actions">
        <Button
          variant="secondary"
          onClick={onBack}
          css={{ marginRight: 'var(--cds-spacing-200)' }}
          data-testid="date-selection-back-button"
        >
          {_t('Back')}
        </Button>
        <Button
          variant="primary"
          onClick={() => onApply(isAllTimeSelected ? undefined : currentDateRange)}
          disabled={!isAllTimeSelected && (!currentDateRange?.endDate || !currentDateRange?.startDate)}
        >
          {_t('Apply')}
        </Button>
      </Actions>
    </TemporaryDrawer>
  );
};

export default ExportDrawerDateSelectionView;
